<div class="container">

    <div *ngIf="fileDetailsDesign.length > 0" class="p-2">
        <div class="row align-items-end mb-2">
          <div class="d-flex col text-start justify-content-between align-items-center" style="color: #205567;">
            <p class="m-0">Please review Design and Visalisation files</p>
            <button (click)="close()" class="customPreActivatedButtons p-1"><mat-icon>close</mat-icon></button>
          </div>
          <!-- <div class="mb-auto w-100"></div> -->
        </div>
        <hr class="mb-1">
    </div>

  
    <div *ngIf="fileDetailsVisual.length > 0">
      <div class="row align-items-end mb-2">
        <div class="col text-start" style="color: #205567;">3D Visalisation files</div>
      </div>
      <ul class="list-group mb-1">
        <li class="py-1 list-group-item d-flex justify-content-between align-items-center gap-3" *ngFor="let file of fileDetailsVisual">
          <span style="color:#205567;" class="text-truncate">
            {{file.fileName}}
          </span>
          <div>
            <span (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567;cursor:pointer;"></i>
            </span>
          </div>
        </li>
      </ul>
      <hr class="mb-1">
    </div>

    <div *ngIf="fileDetailsCorrectedVisual.length > 0">
      <div class="row align-items-end mb-2">
        <div class="col text-start" style="color: #205567;">Corrected 3D Visalisation files</div>
      </div>
      <ul class="list-group mb-1">
        <li class="py-1 list-group-item d-flex justify-content-between align-items-center gap-3" *ngFor="let file of fileDetailsCorrectedVisual">
          <span style="color:#205567;"class="text-truncate">
            {{file.fileName}}
          </span>
          <div>
            <div (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567;cursor:pointer;"></i>
            </div>
          </div>
        </li>
      </ul>
      <hr class="mb-1">
    </div>


    <div *ngIf="fileDetailsVisual.length > 0">
      <div class="row align-items-end mb-2">
        <div class="col text-start" style="color: #205567;">Provide Feedback</div>
      </div>
      
      <div class="row align-items-end">
        <div class="col text-start" style="color: #205567;">
            <div class="d-flex flex-wrap gap-2">
                <div>
                  <button [ngClass]="{'selected-chip': feedbackId == '3'}"
                        class="border rounded-3 px-2 py-1 shadow-sm" selectable (click)="feedbackId = '3'" [disabled]="taskStatus != 'PF' && feedbackId != '3'">Approve</button>
                </div>
                <div>
                  <button [ngClass]="{'selected-chip': feedbackId == '2'}"
                        class="border rounded-3 px-2 py-1 shadow-sm" selectable (click)="feedbackId = '2'" [disabled]="(taskStatus != 'PF' && feedbackId != '2') || remainingCorrections <= 0">Corrections Required</button>
                        <p class="m-0 ps-2" style="font-size: x-small;">Remaining {{tier}} Corrections: {{remainingCorrections}}</p>
                </div>
                <div>
                  <button [ngClass]="{'selected-chip': feedbackId == '1'}"
                        class="border rounded-3 px-2 py-1 shadow-sm" selectable (click)="feedbackId = '1'" [disabled]="taskStatus != 'PF' && feedbackId != '1'">Cancel Task</button>
                </div>
                
            </div>
        </div>
      </div>

      <div class="row mt-4" *ngIf="feedbackId == '2'">
        <div class="col d-flex justify-content-end gap-2">
          <span>Correction comments: </span>
          <textarea rows="2" [(ngModel)]="comment" style="width: 100%; overflow: hidden; resize: none;"></textarea>
        </div>
      </div>

      <div class="row mt-4" *ngIf="feedbackId == '1'">
        <div class="col d-flex justify-content-end gap-2">
          <span>Reason for Cancellation: </span>
          <select type="select" [(ngModel)]="cancelReason" class="form-select" [disabled]="taskStatus != 'PF'">
            <option value=""></option>
            <option value="Late Delivery by the Seller">Late Delivery by the Seller</option>
            <option value="Unmet Requirements">Unmet Requirements</option>
            <option value="Mutual Cancellation">Mutual Cancellation</option>
          </select>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col d-flex align-items-center justify-content-between gap-2">
          <div class="d-flex align-items-center gap-2" style="color: #205567;">
            <!-- <span *ngIf="feedbackId == '1' || feedbackId == '3'"> -->

              <p class="m-0" *ngIf="feedbackId == '3'">Designer Rating:</p>
              <div class="star-rating" *ngIf="feedbackId == '3'">
                <span *ngFor="let star of stars; let i = index"
                  (click)="rate(i + 1)" (mouseenter)="hover(i + 1)" (mouseleave)="hover(0)"
                  class="star" [class.filled]="(hoveredRating || rating) > i">
                  ★
                </span>
              </div>
            
            <!-- </span> -->
          </div>

          <button class="customPreActivatedButtons" (click)="submitFeedback()" *ngIf="taskStatus == 'PF'">Save</button>
          <!-- <button class="customPreActivatedButtons" (click)="close()">Close</button> -->
        </div>
      </div>

      <hr>
    </div>
  
    <div *ngIf="fileDetailsDesign.length > 0">
      <div class="row align-items-end mb-2">
        <div class="col text-start" style="color: #205567;">Design Files <span class="m-0" *ngIf="feedbackId != '3' || taskStatus != 'CO'" style="font-size: x-small;">(Design files will be unlocked upon approval)</span></div>
      </div>
      <ul class="list-group">
        <li class="py-1 list-group-item d-flex justify-content-between align-items-center gap-3" *ngFor="let file of fileDetailsDesign">
          <div style="color: #205567;" class="text-truncate">
            {{file.fileName}}
          </div>
          <div>
            <div *ngIf="feedbackId == '3' && taskStatus == 'CO'" (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567;"></i>
            </div>
            <div *ngIf="feedbackId != '3' || taskStatus != 'CO'" style="cursor: default !important;">
                <i class="fa fa-lock" style="color: #205567;"></i>
            </div>
          </div>
        </li>
      </ul>
      <hr>
    </div>

    <div *ngIf="fileDetailsCorrectedDesign.length > 0">
      <div class="row align-items-end mb-2">
        <div class="col text-start" style="color: #205567;">Corrected Design Files <span class="m-0" *ngIf="feedbackId != '3' || taskStatus != 'CO'" style="font-size: x-small;">(Corrected Design files will be unlocked upon approval)</span></div>
      </div>
      <ul class="list-group">
        <li class="py-1 list-group-item d-flex justify-content-between align-items-center gap-3" *ngFor="let file of fileDetailsCorrectedDesign">
          <div style="color: #205567;" class="text-truncate">
            {{file.fileName}}
          </div>
          <div>
            <div *ngIf="feedbackId == '3' && taskStatus == 'CO'" (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567;"></i>
            </div>
            <div *ngIf="feedbackId != '3' || taskStatus != 'CO'" style="cursor: default !important;">
                <i class="fa fa-lock" style="color: #205567;"></i>
            </div>
          </div>
        </li>
      </ul>
      <hr>
    </div>
  
  
  </div>
  
  <div class="spinner-overlay" *ngIf="dataService.progressBarActiveForSlider">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>